import React, { useState, useEffect } from 'react';
import { userSettingsAPI } from '../../services/api';
import './SettingsPage.css';

function ReferMates() {
  const [loading, setLoading] = useState(true);
  const [referralLink, setReferralLink] = useState('');
  const [stats, setStats] = useState({ referrals: 0, joined: 0 });
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    loadReferralData();
  }, []);

  const loadReferralData = async () => {
    try {
      const [linkData, statsData] = await Promise.all([
        userSettingsAPI.getReferralLink(),
        userSettingsAPI.getReferralStats(),
      ]);

      // Map API response to component state
      setReferralLink(linkData.referral_link || '');
      setStats({
        referrals: statsData.total_referrals || 0,
        joined: statsData.active_referrals || 0,
      });
    } catch (error) {
      console.error('Failed to load referral data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="settings-page-content">
      <h2>Refer Your Mates</h2>
      <p className="page-description">
        Invite your friends to join PuntClub and earn rewards!
      </p>

      <div className="form-section">
        <h3>Your Referral Link</h3>
        <div className="referral-link-container">
          <input
            type="text"
            value={referralLink}
            readOnly
            className="referral-link-input"
          />
          <button onClick={handleCopy} className="btn btn-primary">
            {copied ? 'Copied!' : 'Copy Link'}
          </button>
        </div>
      </div>

      <div className="form-section">
        <h3>Referral Stats</h3>
        <div className="referral-stats-grid">
          <div className="stat-card">
            <div className="stat-value">
              {stats.referrals}
            </div>
            <div className="stat-label">Total Referrals</div>
          </div>
          <div className="stat-card">
            <div className="stat-value stat-value-success">
              {stats.joined}
            </div>
            <div className="stat-label">Successfully Joined</div>
          </div>
        </div>
      </div>

      <div className="info-box">
        <p>
          <strong>How it works:</strong>
        </p>
        <ol>
          <li>Share your unique referral link with friends</li>
          <li>They sign up using your link</li>
          <li>You both earn rewards when they join a club!</li>
        </ol>
      </div>
    </div>
  );
}

export default ReferMates;
